export default "__VITE_ASSET__CwZoYQct__"